.root {
  position: relative;
  overflow: hidden;
  border: 1px solid var(--color-code-border);
  border-radius: var(--radius-xl);
  background: var(--color-code-background);
  color: var(--color-code-foreground);
  box-shadow: var(--shadow-xs);
}

.pre {
  margin: 0;
  overflow-x: auto;
  padding: 0.875rem 1rem;
  border: 0;
  border-radius: 0;
  background: var(--color-code-background) !important;
  color: var(--color-code-foreground);
  font-family: var(--font-mono);
  font-size: 0.8125rem;
  line-height: 1.65;
  tab-size: 2;
}

.pre code,
.pre span {
  background: transparent !important;
}

.pre code {
  font: inherit;
}

.copy {
  position: absolute;
  top: 0.5rem;
  inset-inline-end: 0.5rem;
  color: var(--color-code-muted);
  opacity: 0;
  transition: opacity 150ms ease;
}

.copy:hover {
  color: var(--color-code-foreground);
}

.root:hover .copy,
.copy:focus-visible {
  opacity: 1;
}

@media (hover: none) {
  .copy {
    opacity: 1;
  }
}
